import React, { useState, useEffect } from "react";
import { Input, Typography } from "antd";
import axios from "axios";
import { API_URL } from "../../../config";

const { TextArea } = Input;
const { Title } = Typography;

function useDebounce(value, delay) {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return debouncedValue;
}

const DoctorNotesForm = ({ appointment_id, loginDoctorDetails }) => {
  const { doctor_id } = loginDoctorDetails;
  const [note, setNote] = useState("");
  const debouncedNote = useDebounce(note, 500);

  useEffect(() => {
    const fetchNote = async () => {
      try {
        const response = await axios.get(
          `${API_URL}/appointment/${appointment_id}/notes/`,
        );
        if (response.data && response.data.contents) {
          setNote(response.data.contents);
        }
      } catch (error) {
        console.error("Error fetching note from API:", error);
      }
    };

    fetchNote();
  }, [appointment_id]);

  const handleNoteChange = (e) => {
    const newNote = e.target.value;
    setNote(newNote);
  };

  useEffect(() => {
    if (debouncedNote) {
      saveNoteToApi(debouncedNote);
    }
  }, [debouncedNote]);

  const saveNoteToApi = async (newNote) => {
    try {
      const apiUrl = `${API_URL}/appointment/${appointment_id}/notes/`;
      await axios.put(apiUrl, {
        title: appointment_id,
        contents: newNote,
        doctor_id: doctor_id,
      });
      console.log("Note saved successfully to the API.");
    } catch (error) {
      console.error("Error saving note to API:", error);
    }
  };

  return (
    <React.Fragment>
      <Title level={5}>Consultation Note</Title>
      <TextArea
        rows={4}
        placeholder="Summary note for consultation"
        value={note}
        onChange={handleNoteChange}
      />
    </React.Fragment>
  );
};

export default DoctorNotesForm;
